/* Email addresses are assembled in the browser and never written into the HTML.

   A harvester is a regex over the source: `mailto:` links and anything shaped like
   name@domain are the whole catch. So the markup ships `data-mu` / `data-md` and a human
   fallback reading "support (at) rise8musicgifts.com" — legible to a person, invisible to
   \S+@\S+. On load the link becomes a real mailto. Someone with JS off still gets an address
   they can read and type.

   This is not security; a scraper running a headless browser gets it anyway, and the address
   is printed on every retail box. It removes the address from the cheap bulk sweep that
   produces most of the spam, and that is all it claims to do. The real protection on the forms
   is Shopify's hCaptcha, which is on by default.

   Loaded on every page from layout/theme.liquid, because the address can appear in the footer
   or a policy page as well as on Contact.
*/
(function () {
  var AT = String.fromCharCode(64);
  var links = document.querySelectorAll('[data-mu][data-md]');
  for (var i = 0; i < links.length; i++) {
    var a = links[i];
    var addr = a.getAttribute('data-mu') + AT + a.getAttribute('data-md');
    a.setAttribute('href', 'mailto:' + addr);
    a.textContent = addr;
  }
})();
